import {FetchError} from 'ofetch'

const SERVER_ERROR_CODE = 500

export async function useApiFetch(path, options = {}) {
  const client = useSanctumClient()
  const authStore = useAuthStore()
  const {$i18n} = useNuxtApp()

  let code, message

  options.headers = {
    ...options.headers,
    'Accept-Language': $i18n.locale.value
  }

  try {
    const result = await client(path, options)
    return result
  } catch (error) {
    const isFetchError = error instanceof FetchError
    code = isFetchError ? error.response?.status : SERVER_ERROR_CODE
    message = isFetchError ? error.response?._data.message : {}
    const data = error.response?._data

    if (code === 401 || code === 419) {
      authStore.resetVariables()
    }

    // 세션 만료시 로그인 페이지로 이동
    if (code === 401) window.location.href = '/auth/login'
    console.error('error', {code, message, data})
    throw {
      code,
      message,
      data
    }
  }
}
